export default {
    en: {
        id: 'diagram3b4-5',
        blocks: [
            {
                task: 'S = The Board is now free to do planning',
                answer: 'Free to do X.',
                title: "S = ",
                modelName: 's'
            },
            {
                task: 'C = It is not set up to do planning',
                answer: 'Not set up to do X',
                title: "C = ",
                modelName: 'c'
            },
            {
                task: 'Q = How do we get set up?',
                answer: 'How fix?',
                title: "Q = ",
                modelName: 'q'
            }
        ],
        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
        correctAnswers: 3
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4a/practiceInSeeing/i18n/exercise5.js